import "./BeyondWordsOverride.css";

import {
  ENABLE_ARTICLE_REDESIGN,
  IS_PLAYWRIGHT_TEST,
} from "@helper/getEnvVariables";
import { useBeyondWordsPlayer } from "@hooks/useBeyondWords/useBeyondWordsPlayer";
import { useIsPlayerReady } from "@hooks/useBeyondWords/useIsPlayerReady";
import { useTooltipOnPlayerReady } from "@hooks/useBeyondWords/useTooltipOnBWPlayerReady";
import { BeyondWordsPlayerProps } from "@typings/BeyondWords";

import PlayerTooltip from "./PlayerTooltip";

const BeyondWordsPlayer = (props: BeyondWordsPlayerProps) => {
  const playerRef = useBeyondWordsPlayer(props);
  const playerReady = useIsPlayerReady(playerRef);
  const { showTooltip } = useTooltipOnPlayerReady(playerRef);

  if (IS_PLAYWRIGHT_TEST === "true") return null;

  const isArticleRedesignEnabled = ENABLE_ARTICLE_REDESIGN;

  const containerClasses = isArticleRedesignEnabled ? "mb-0" : "mb-6";

  return (
    <div className={`relative ${containerClasses}`}>
      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-1 animate-fade-in">
          <PlayerTooltip />
        </div>
      )}
      <div className="flex flex-col gap-1 items-start w-full">
        <div className="w-full">
          <div
            ref={playerRef}
            id={`tts-inline-widget-${props.cueId}`}
            className={isArticleRedesignEnabled ? "tts-animate-on-play" : ""}
          />
        </div>
        {playerReady && !isArticleRedesignEnabled && (
          <div className="w-full flex justify-end text-text-muted text-[10px] font-primary font-regular leading-[150%]">
            Generated by AI
          </div>
        )}
      </div>
    </div>
  );
};

export default BeyondWordsPlayer;
